import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import bgImage from '@/assets/Vent_BG-light.png';
import ventLogo from '@/assets/Vent-logo_Primary-tagline-dark.png';

const EXIT_MS = 400;
const NAVY = '#16253E';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { loading } = useAuth();
  const [isExiting, setIsExiting] = useState(false);

  // Lock document scroll while Welcome is mounted.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevBodyPosition = body.style.position;
    const prevBodyHeight = body.style.height;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.height = '100%';
    body.style.width = '100%';
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      body.style.position = prevBodyPosition;
      body.style.height = prevBodyHeight;
      body.style.width = '';
    };
  }, []);

  const handleGetStarted = () => {
    if (isExiting) return;
    setIsExiting(true);
    window.setTimeout(() => navigate('/auth'), EXIT_MS);
  };

  return (
    <div
      className={[
        'fixed inset-0 overflow-hidden flex flex-col',
        'transition-all ease-out duration-400',
        isExiting ? 'opacity-0 -translate-y-2' : 'opacity-100 translate-y-0',
      ].join(' ')}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div
        className="flex-1 flex flex-col items-center justify-center px-8"
        style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
      >
        <img src={ventLogo} alt="Vent — Designed to help you let it out" className="w-full max-w-[300px]" />
      </div>

      {/* Bottom: spinner while auth loads, Get Started when ready. Same height
          either way so the logo above doesn't shift between states. */}
      <div
        className="px-8 flex justify-center items-center min-h-[64px]"
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 2.5rem)' }}
      >
        {loading ? (
          <div
            className="welcome-spinner"
            aria-label="Loading"
            role="status"
          />
        ) : (
          <button
            type="button"
            onClick={handleGetStarted}
            disabled={isExiting}
            className="w-full max-w-[260px] rounded-full py-3.5 text-white font-medium text-base disabled:opacity-70 transition-opacity duration-200"
            style={{ backgroundColor: NAVY }}
          >
            Get Started
          </button>
        )}
      </div>

      <style>{`
        .welcome-spinner {
          width: 28px;
          height: 28px;
          border: 2.5px solid rgba(22, 37, 62, 0.15);
          border-top-color: ${NAVY};
          border-radius: 50%;
          animation: welcome-spin 0.8s linear infinite;
        }
        @keyframes welcome-spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default Welcome;
